import React, { useEffect, useState } from 'react';

import {
  ModalFooter,
  ModalFormSection,
  ModalV2,
} from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { showError } from '@utils';

import { Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import { subscriptionsServices } from '@services';
import styles from './AddContractModal.style';

const AddContractModal = ({
  open,
  onClose,
  subscriptionId,
  onGetSubscriptionAndContracts,
}) => {
  const [loadingContracts, setLoadingContracts] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contractTypes, setContractTypes] = useState([]);
  const methods = useForm({
    mode: 'onChange',
  });
  const { handleSubmit } = methods;

  const getContractTypes = async () => {
    try {
      setLoadingContracts(true);
      const { data } =
        await subscriptionsServices.getSubscriptionContractsTemplates();
      const templates = data?.map((template) => ({
        ...template,
        value: template.id,
        text: template.name,
      }));
      setContractTypes(templates);
    } catch (error) {
      showError(error);
      setContractTypes([]);
    } finally {
      setLoadingContracts(false);
    }
  };

  useEffect(() => {
    if (open) {
      getContractTypes();
      methods.reset({ template: '' });
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeContract = (value) => {
    methods.setValue('template', value);
  };

  const handleContractSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      await subscriptionsServices.addContract({
        template_id: values.template,
        subscription_id: subscriptionId,
      });
      onGetSubscriptionAndContracts();
    } catch (error) {
      showError(error);
    } finally {
      setIsSubmitting(false);
      onClose();
    }
  };

  return (
    <ModalV2
      isOpen={open}
      onClose={onClose}
      isLoading={isSubmitting}
      title="Add Contract"
      maxWidth="sm"
    >
      <ModalFormSection>
        <form onSubmit={handleSubmit(handleContractSubmit)}>
          <Box sx={styles.fieldRow}>
            <FieldV2
              isRequired
              name="template"
              label="Template"
              type="dropdown"
              options={contractTypes}
              control={methods.control}
              onChange={handleChangeContract}
              loading={loadingContracts || isSubmitting}
              placeholder="Select a template"
            />
          </Box>
          <ModalFooter>
            <ButtonV2 variant="secondary" onClick={onClose}>
              Cancel
            </ButtonV2>
            <ButtonV2 type="submit" loading={isSubmitting}>
              OK
            </ButtonV2>
          </ModalFooter>
        </form>
      </ModalFormSection>
    </ModalV2>
  );
};

export default AddContractModal;
